// Registers the network-first service worker (public/sw.js).
// Only active in production builds; dev (react-scripts start) stays SW-free
// so hot-reload is never intercepted.
export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
